import { connect } from 'react-redux'
import { googleAnalyticsEvent } from 'Modules/googleAnalytics/actions'

import RenderFilterSection from './RenderFilterSection'


const mapStateToProps = (state) => (
  {
    searchQueryObj: state.location.lastSearchObj,
    filterLookup: state.searchFilters.filterLookup,
    filterOrders: state.searchFilters.filterOrders,
    lookups: state.lookups,
  }
)
const actions = {
  googleAnalyticsEvent,
}

export default connect(mapStateToProps, actions)(RenderFilterSection)
